import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UnpaidChartersComponent } from './unpaid-charters.component';
import { UnpaidChartersResolve } from './unpaid-charters.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'unpaid-charters',
        component: UnpaidChartersComponent,
        resolve: {
          portal: UnpaidChartersResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class UnpaidChartersRoutingModule {}
